export const MAX_FILE_SIZE_IN_BYTES = 20 * 1024 * 1024
